export default __webpack_public_path__ + "static/media/anastasia.73e79e35.webp";